/**
 * This file was auto-generated by Fern from our API Definition.
 */

/**
 * @example
 *     {}
 */
export interface KeyHistoryRequest {
    /** The ETag of the latest version of the resource. */
    ifNoneMatch?: string;
}
